import auth from "./services/auth.service";
import comment from "./services/comment.service";
import event from "./services/event.service";
import feature from "./services/feature.service";
import file from "./services/file.service";
import messaging from "./services/messaging.service";
import notification from "./services/notification.service";
import project from "./services/project.service";
import team from "./services/team.service";
import user from "./services/user.service";

export interface IResponse<T> {
  version: String;
  success: boolean;
  statusCode: number;
  errorCode?: String;
  errorMessage?: String;
  result?: T;
}

export interface IPaginatedResponse<T> {
  version: String;
  success: boolean;
  statusCode: number;
  errorCode?: String;
  errorMessage?: String;
  result?: {
    content: T;
    empty: boolean;
    first: true;
    last: true;
    number: number;
    numberOfElements: number;
    pageable: {
      offset: number;
      pageNumber: number;
      pageSize: number;
      paged: boolean;
      sort: {
        empty: boolean;
        sorted: boolean;
        unsorted: boolean;
      };
      unpaged: boolean;
    };
    size: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    totalElements: number;
    totalPages: number;
  };
}

export interface ISearchRequest {
  term?: string | null;
  flags?: ISearchCriteria[] | null;
  sort?: ISortCriteria[] | null;
  criteria?: ISearchCriteria[] | null;
  page?: number | null;
  size?: number | null;
}

export interface ISearchCriteria {
  key: string;
  operation: string;
  value: string;
}

export interface ISortCriteria {
  key: string;
  direction?: "asc" | "desc";
}

const api = {
  auth,
  user,
  team,
  file,
  project,
  comment,
  messaging,
  notification,
  event,
  feature,
};

export default api;
